export const environment = {
  production: false,
  webServices: {
    Cfo: 'https://stgvestacfoapi.azurewebsites.net/api/',
    fileshare: 'https://filesharewebapi-stage.azurewebsites.net'
  }
};
